import Colors from 'enums/Colors';
import { Description } from 'pages/biblioteca_v2/components/categoria-item/DefaultItem.styled';
import { TextDangerouslySetInnerHtml } from 'pages/recursos/recursos-conteudo/RecursosConteudoPage.styled';
import styled from 'styled-components';

const SessionFerramentaVideoStyle = {
    Container: styled.div<{ img?: string }>`
        /* Exibe gradiente horizontal, gradiente vertical, imagem e cor sólida */
        background: ${props =>
            props.img
                ? `
                    linear-gradient(270deg, rgba(0, 60, 120, 0.4) 40%, #003c78 90%),
                    linear-gradient(180deg, rgba(0, 60, 120, 0.4) 60%, #003c78 100%),
                    url(${props.img}), #003c78
                `
                : `
                  linear-gradient(270deg, rgba(0, 60, 120, 0.4) 0%, #003C78 70%);

                    
                `};
        background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
        background-size: 100%;
        background-position: top, top, center, top;
        color: white;
        padding: ${props => (props.img ? '80px' : '32px 329px')};
        display: flex;
        flex-direction: column;
        gap: 24px;
        min-height: 680px;

        section {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        @media screen and (max-width: 1500px) {
            padding: 32px 140px;
        }

        @media screen and (max-width: 1080px) {
            background-size: cover;
        }
        @media screen and (max-width: 600px) {
            padding: 0px;
        }
    `,

    Content: styled.div`
        display: flex;
        flex-direction: column;
        padding: 37px 73px 37px 73px;
    `,

    Body: styled.div<{ twoColumns?: boolean }>`
        display: grid;
        grid-template-columns: ${props => (props.twoColumns ? '1fr 1fr' : '1fr')};
        width: 100%;
        gap: 64px;
        margin-top: 22px;

        @media screen and (max-width: 1180px) {
               grid-template-columns: 1fr;
        }
    `,

    Ferramenta: {
        Container: styled.div`
            display: flex;
            flex-direction: column;
            gap: 26px;
            color: ${Colors.White};
        `,

        Title: styled.h2`
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 38px;
            line-height: 100%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
        `,

        Description: styled(TextDangerouslySetInnerHtml)`
            font-family: 'Barlow';
            font-weight: 400;
            font-size: 22px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            max-width: 720px;
            margin: 0;
        `,
    },
};

export default SessionFerramentaVideoStyle;
